"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _excluded = ["icon"];
var Icon = exports.Icon = (0, _styledComponents["default"])(function Icon(_ref) {
  var IconComponent = _ref.icon,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(IconComponent, Object.assign({
    size: "medium"
  }, props));
}).withConfig({
  displayName: "Icon",
  componentId: "sc-3c2j46-0"
})(["color:", ";"], (0, _index.cssColorValue)('essentialBase'));